/* Positive Empathetic's — interactive layer
   Sticky pre-order bar, day/dusk toggle, scroll-revealed story.
   No dependencies. Degrades to plain content if JS is off. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Sticky pre-order bar -------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-pe-sticky]');
    if (!bar) return;

    var form = document.querySelector('product-info form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');
    var anchor = document.querySelector('[data-pe-sticky-anchor]')
      || document.querySelector('product-info .product-form__buttons')
      || form;

    var cta = bar.querySelector('[data-pe-sticky-cta]');
    if (cta && form) {
      cta.addEventListener('click', function () {
        var submit = form.querySelector('[type="submit"], button[name="add"]');
        if (submit) {
          submit.click();
        } else {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
    }

    if (!anchor || !('IntersectionObserver' in window)) {
      // Fallback: reveal once the visitor has scrolled a screen's worth.
      window.addEventListener('scroll', function () {
        bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.8);
      }, { passive: true });
      return;
    }

    // Show the bar only once the real add-to-cart button has scrolled away.
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var below = entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !entry.isIntersecting && below);
      });
    }, { rootMargin: '0px 0px -20px 0px', threshold: 0 }).observe(anchor);
  }

  /* ---- Day / dusk toggle ----------------------------------------------- */
  function initLume() {
    document.querySelectorAll('[data-pe-lume]').forEach(function (root) {
      var stamp = root.querySelector('[data-pe-lume-stamp]');
      var buttons = root.querySelectorAll('[data-pe-lume-mode]');
      if (!buttons.length) return;

      // Preload the dusk frame so the first switch doesn't flash.
      var dusk = root.querySelector('.pe-lume__img--dusk');
      if (dusk && dusk.dataset.src && !dusk.src) dusk.src = dusk.dataset.src;

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-pe-lume-mode');
          root.classList.toggle('is-dusk', mode === 'dusk');
          buttons.forEach(function (b) {
            b.setAttribute('aria-pressed', String(b === btn));
          });
          if (stamp) {
            stamp.textContent = btn.getAttribute('data-pe-lume-stamp-text') || '';
          }
        });
      });
    });
  }

  /* ---- Scroll-revealed story ------------------------------------------ */
  function initStory() {
    var chapters = document.querySelectorAll('.pe-story__chapter');
    if (!chapters.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      chapters.forEach(function (c) { c.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

    chapters.forEach(function (c) { io.observe(c); });
  }

  function boot() {
    initSticky();
    initLume();
    initStory();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run inside the theme editor when a section is redrawn.
  document.addEventListener('shopify:section:load', boot);
})();
